import { DEFAULT_INVOICE_LANGUAGE } from '@features/invoices/constants/defaultInvoiceLanguage'
import { DEFAULT_INVOICE_PAYMENT_TERM } from '@features/invoices/constants/defaultInvoicePaymentTerm'
import { isInvoiceLanguage } from '@features/invoices/utils/isInvoiceLanguage'
import { isInvoiceProductType } from '@features/products/utils/isInvoiceProductType'

import { NumberValue } from '../../../utils'
import type { useGetZervantDocumentSettings } from '../hooks/useGetZervantDocumentSettings'

type GetDefaultSettingsValue = ReturnType<typeof useGetZervantDocumentSettings>['getDefaultSettingsValue']

// Reads the document defaults shared by the Presets section and the legacy org invoice settings.
export const getDocumentDefaultsFormValues = (getDefaultSettingsValue: GetDefaultSettingsValue) => {
  const language = getDefaultSettingsValue('language')
  const paymentTerm = getDefaultSettingsValue('paymentTime')
  const productType = getDefaultSettingsValue('productType')

  return {
    currency: getDefaultSettingsValue('currency'),
    language: isInvoiceLanguage(language) ? language : DEFAULT_INVOICE_LANGUAGE,
    // "0" is a real payment term ("today"), so only a missing value falls back to 30 days.
    paymentTerm: new NumberValue(paymentTerm ?? DEFAULT_INVOICE_PAYMENT_TERM).getValue(),
    productType: isInvoiceProductType(productType) ? productType : undefined,
  }
}
